import React from 'react';
import { ImageFadeIn } from '../components/animations/ImageFadeIn';
import { ScrollReveal } from '../components/animations/ScrollReveal';
import { Shield, HeartPulse, AlertTriangle, Target, Car, Home, Siren, Radio, Wind, Home as HomeIcon, Flame, BoxIcon } from 'lucide-react';
const ProgramsPage = () => {
  return <div className="w-full min-h-screen bg-white" data-id="element-663" data-mp="365iwz4r1jv1">
      {/* Hero Section */}
      <div className="relative min-h-[60vh] flex items-center bg-cover bg-center" style={{
      backgroundImage: "url('https://uploadthingy.s3.us-west-1.amazonaws.com/f58KckxayorY4pRqcLQxf9/000_QQ3AP-e1502868300864.webp')"
    }} data-id="element-664" data-mp="3udzzukri6tnm">
        <div className="absolute inset-0 bg-black/60" data-id="element-665" data-mp="3gm3csv4oz9y3"></div>
        <div className="relative z-10 w-full pt-36 sm:pt-52 md:pt-56 pb-16 sm:pb-20" data-id="element-666" data-mp="3gjgymcnapw6w">
          <div className="max-w-5xl mx-auto px-4 sm:px-6 text-center" data-id="element-667" data-mp="3blp2f6fmbnww">
            <h1 className="text-3xl sm:text-5xl md:text-6xl font-bold text-white tracking-tight mb-4 sm:mb-6" data-id="element-668" data-mp="36ofa9j0ugy5d">
              Our Programs
            </h1>
            <p className="text-lg sm:text-xl md:text-2xl text-white/90 max-w-3xl mx-auto font-light leading-relaxed" data-id="element-669" data-mp="1qpzlypz2jhiq">
              Comprehensive training designed to equip Israeli civilians with
              life-saving skills
            </p>
          </div>
        </div>
      </div>
      {/* Self-Defense & Weapons Readiness */}
      <section className="py-20 sm:py-24" data-id="element-670" data-mp="25n0euwszxiis">
        <div className="max-w-5xl mx-auto px-4 sm:px-6" data-id="element-671" data-mp="25l5r7aqcbcb0">
          <ScrollReveal animation="fade" data-id="element-672" data-mp="29nu1znym6tam">
            <div className="text-center mb-16" data-id="element-673" data-mp="29mrapexdqou6">
              <div className="inline-flex items-center justify-center mb-4" data-id="element-674" data-mp="1vpvnmikamwv4">
                <Shield className="w-8 h-8 text-blue-500 mr-2" data-id="element-675" data-mp="20nx9fb93taaa" />
                <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 tracking-tight" data-id="element-676" data-mp="20q9zkbp0mqyf">
                  Self-Defense & Weapons Readiness
                </h2>
              </div>
              <p className="text-xl text-gray-600 max-w-3xl mx-auto" data-id="element-677" data-mp="pala9doahfug">
                Equipping civilians with the skills to protect themselves and
                their communities
              </p>
            </div>
          </ScrollReveal>
          <ScrollReveal animation="scale" delay={0.2} data-id="element-678" data-mp="3sjzvjoi7thla">
            <div className="mb-16" data-id="element-679" data-mp="3sif3c5jdiaql">
              <div className="relative aspect-[16/9] rounded-xl overflow-hidden" data-id="element-680" data-mp="3nkwqw565dddu">
                <ImageFadeIn src="https://uploadthingy.s3.us-west-1.amazonaws.com/f58KckxayorY4pRqcLQxf9/000_QQ3AP-e1502868300864.webp" alt="Civilian woman practicing firearm training with professional instructor" className="w-full h-full object-cover" data-id="element-681" data-mp="3nisnrpg2oiem" />
                <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/80 to-transparent p-6" data-id="element-682" data-mp="34mangjn5ra6r">
                  <p className="text-white text-lg font-light" data-id="element-683" data-mp="17u0rvr87duoh">
                    Indoor firearms training for civilians with professional
                    instructors
                  </p>
                </div>
              </div>
            </div>
          </ScrollReveal>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-x-12 gap-y-10" data-id="element-684" data-mp="1fd9y5blexd9b">
            {selfDefensePrograms.map((program, index) => <ScrollReveal key={index} animation="slide-up" delay={index * 0.1} data-id="element-685" data-mp="1k51l7c5d10up" data-mpi={index}>
                <div className="flex items-start" data-id="element-686" data-mp="1p4w7t3i3r49y">
                  <div className="mr-4 mt-1" data-id="element-687" data-mp="rgcmtkvov9mn">
                    <div className="p-2 rounded-full bg-blue-100" data-id="element-688" data-mp="rhntbsgiqvhg">
                      <program.icon className="w-6 h-6 text-blue-500" data-id="element-689" data-mp="wexoloqla1d7" />
                    </div>
                  </div>
                  <div data-id="element-690" data-mp="11flh6euguq9j">
                    <h3 className="text-xl font-semibold text-gray-900 mb-2" data-id="element-691" data-mp="15eua5hhomk41">
                      {program.title}
                    </h3>
                    <p className="text-base text-gray-700 leading-relaxed" data-id="element-692" data-mp="2crw0zvr8fc1u">
                      {program.description}
                    </p>
                  </div>
                </div>
              </ScrollReveal>)}
          </div>
        </div>
      </section>
      {/* Medical Readiness */}
      <section className="py-20 sm:py-24 bg-gray-50" data-id="element-693" data-mp="2afk25942te8p">
        <div className="max-w-5xl mx-auto px-4 sm:px-6" data-id="element-694" data-mp="2pb037y32qael">
          <ScrollReveal animation="fade" data-id="element-695" data-mp="2pckw7j9qplac">
            <div className="text-center mb-16" data-id="element-696" data-mp="2kbnet8wk0v9w">
              <div className="inline-flex items-center justify-center mb-4" data-id="element-697" data-mp="2kavi1ur80ri1">
                <HeartPulse className="w-8 h-8 text-blue-500 mr-2" data-id="element-698" data-mp="2yawl9guykb0o" />
                <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 tracking-tight" data-id="element-699" data-mp="2td4uiq61uuy2">
                  Medical Readiness
                </h2>
              </div>
              <p className="text-xl text-gray-600 max-w-3xl mx-auto" data-id="element-700" data-mp="383u8g0awao5m">
                Saving lives when every second counts
              </p>
            </div>
          </ScrollReveal>
          <ScrollReveal animation="scale" delay={0.2} data-id="element-701" data-mp="3h2pd37yajq6t">
            <div className="mb-16" data-id="element-702" data-mp="3d1nach560w03">
              <div className="relative aspect-[16/9] rounded-xl overflow-hidden" data-id="element-703" data-mp="3d2f3zmf7cjnq">
                <ImageFadeIn src="https://uploadthingy.s3.us-west-1.amazonaws.com/2RzD3Hv3ZwgDzrjzRUzjmU/0473_LMQE_IchudHatzalah_GadiYampel_1GY9847-scaled-1.jpg" alt="Medical training session" className="w-full h-auto rounded-lg" data-id="element-704" data-mp="3vqfyk9b3ka9p" />
                <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/80 to-transparent p-6" data-id="element-705" data-mp="3rm855ytp2655">
                  <p className="text-white text-lg font-light" data-id="element-706" data-mp="3cxc2khaeplbx">
                    Emergency medical response team training with patient
                    evacuation
                  </p>
                </div>
              </div>
            </div>
          </ScrollReveal>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-x-12 gap-y-10" data-id="element-707" data-mp="380lkxpiyehoe">
            {medicalPrograms.map((program, index) => <ScrollReveal key={index} animation="slide-up" delay={index * 0.1} data-id="element-708" data-mp="2u1vng8s82fzi" data-mpi={index}>
                <div className="flex items-start" data-id="element-709" data-mp="14ix5h8c9b4t1">
                  <div className="mr-4 mt-1" data-id="element-710" data-mp="14krt4uewxb0t">
                    <div className="p-2 rounded-full bg-red-100" data-id="element-711" data-mp="zroui7va3bdr">
                      <program.icon className="w-6 h-6 text-red-500" data-id="element-712" data-mp="vqd25ul0sc1v" />
                    </div>
                  </div>
                  <div data-id="element-713" data-mp="qrsd8rb7xesq">
                    <h3 className="text-xl font-semibold text-gray-900 mb-2" data-id="element-714" data-mp="qsbj39nlgcqe">
                      {program.title}
                    </h3>
                    <p className="text-base text-gray-700 leading-relaxed" data-id="element-715" data-mp="1nff2a45ypuw5">
                      {program.description}
                    </p>
                  </div>
                </div>
              </ScrollReveal>)}
          </div>
        </div>
      </section>
      {/* All-Hazard Emergency Response */}
      <section className="py-20 sm:py-24" data-id="element-716" data-mp="31oasn9rnl3b">
        <div className="max-w-5xl mx-auto px-4 sm:px-6" data-id="element-717" data-mp="32h8kyqqz09b">
          <ScrollReveal animation="fade" data-id="element-718" data-mp="3u88vzqd53ysf">
            <div className="text-center mb-16" data-id="element-719" data-mp="3u77lpo3y7gbr">
              <div className="inline-flex items-center justify-center mb-4" data-id="element-720" data-mp="3k42aewrqnb04">
                <AlertTriangle className="w-8 h-8 text-blue-500 mr-2" data-id="element-721" data-mp="3k1xvzkw7qtll" />
                <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 tracking-tight" data-id="element-722" data-mp="3p3x0iy3ovwk4">
                  All-Hazard Emergency Response
                </h2>
              </div>
              <p className="text-xl text-gray-600 max-w-3xl mx-auto" data-id="element-723" data-mp="2nstxifvhaiy">
                Preparing for any crisis that threatens Israeli communities
              </p>
            </div>
          </ScrollReveal>
          <ScrollReveal animation="scale" delay={0.2} data-id="element-724" data-mp="bn7hoa4nn6zr">
            <div className="mb-16" data-id="element-725" data-mp="gnbyy2de05r1">
              <div className="relative aspect-[16/9] rounded-xl overflow-hidden" data-id="element-726" data-mp="gn23hz9kp6dy">
                <ImageFadeIn src="https://uploadthingy.s3.us-west-1.amazonaws.com/8S9Uyq78LzUKFgJpwgjEFN/IS-NEWS_Earthquake-in-Turkey-Photo-2-Israelis-at-Turkey-earthquake.jpg" alt="Emergency response team in helmets responding to a disaster scene" className="w-full h-full object-cover" data-id="element-727" data-mp="lmyc6bt7tlzu" />
                <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/80 to-transparent p-6" data-id="element-728" data-mp="t3usavqijnwj">
                  <p className="text-white text-lg font-light" data-id="element-729" data-mp="12vr419livcj8">
                    Disaster response team training in hazardous environments
                  </p>
                </div>
              </div>
            </div>
          </ScrollReveal>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-x-12 gap-y-10" data-id="element-730" data-mp="a84t1g9yt5mc">
            {emergencyPrograms.map((program, index) => <ScrollReveal key={index} animation="slide-up" delay={index * 0.1} data-id="element-731" data-mp="5a34wgxomg40" data-mpi={index}>
                <div className="flex items-start" data-id="element-732" data-mp="f5wrkt547pzi">
                  <div className="mr-4 mt-1" data-id="element-733" data-mp="f895mv7r5g7a">
                    <div className="p-2 rounded-full bg-amber-100" data-id="element-734" data-mp="1um5cgqarnwni">
                      <program.icon className="w-6 h-6 text-amber-600" data-id="element-735" data-mp="1qlbojwxbqhum" />
                    </div>
                  </div>
                  <div data-id="element-736" data-mp="1y4b4fslktr98">
                    <h3 className="text-xl font-semibold text-gray-900 mb-2" data-id="element-737" data-mp="1y41hkdvtw07r">
                      {program.title}
                    </h3>
                    <p className="text-base text-gray-700 leading-relaxed" data-id="element-738" data-mp="231kvfcom6az6">
                      {program.description}
                    </p>
                  </div>
                </div>
              </ScrollReveal>)}
          </div>
        </div>
      </section>
      {/* CTA Section */}
      <ScrollReveal animation="fade" data-id="element-739" data-mp="2gxolquwd9z6d">
        <section className="bg-israel-blue text-white py-16 sm:py-20" data-id="element-740" data-mp="2luoqn2hhcvvw">
          <div className="max-w-4xl mx-auto px-4 sm:px-6 text-center" data-id="element-741" data-mp="275iwhsxi1vuv">
            <h2 className="text-3xl sm:text-4xl font-bold mb-6 tracking-tight" data-id="element-742" data-mp="273g637sfq0pm">
              Experience Our Training Center
            </h2>
            <p className="text-xl opacity-90 mb-8 max-w-2xl mx-auto font-light" data-id="element-743" data-mp="2ztodc4lfn0pf">
              When in Israel, come visit the state-of-the-art facilities that
              you helped build and see how we're preparing Israeli civilians for
              any threat
            </p>
            <a href="/training-center" className="inline-block px-8 py-4 bg-white text-israel-blue font-semibold rounded-lg hover:bg-gray-100 transition-colors text-lg shadow-lg" data-id="element-744" data-mp="3sqmmza2ao80w">
              Explore Our Training Center
            </a>
          </div>
        </section>
      </ScrollReveal>
    </div>;
};
const selfDefensePrograms = [{
  icon: AlertTriangle,
  title: 'Situational Awareness',
  description: 'Training to identify potential dangers before they escalate, helping civilians recognize threats in their environment'
}, {
  icon: Home,
  title: 'Close-Quarters Defense',
  description: 'Tactics for countering attackers who breach homes, vehicles, or public spaces, ensuring safety in confined areas'
}, {
  icon: Car,
  title: 'Defensive Driving',
  description: 'Maneuvers for responding to roadside ambushes and vehicular attacks, keeping families safe while traveling'
}, {
  icon: Target,
  title: 'Weapons Proficiency',
  description: 'Drills focused on accuracy under stress, ensuring responsible and effective weapon use'
}, {
  icon: Shield,
  title: 'Immediate Action Drills',
  description: 'Rapid deployment of defensive measures, barricading, and organized threat engagement for community protection'
}, {
  icon: Radio,
  title: 'Alert Systems',
  description: 'Use of personal and community alert systems to coordinate quick response teams during emergencies'
}];
const medicalPrograms = [{
  icon: HeartPulse,
  title: 'Trauma Care',
  description: 'Specialized treatment for gunshot wounds, stabbings, and explosive injuries when professional help is delayed'
}, {
  icon: BoxIcon,
  title: 'Bleeding Control',
  description: 'Use of tourniquets, wound packing, and pressure bandages to stop severe bleeding in emergency situations'
}, {
  icon: Shield,
  title: 'Improvised Medical Solutions',
  description: 'Creating effective medical aids when standard supplies are unavailable, using everyday items to save lives'
}, {
  icon: Siren,
  title: 'Multiple-Casualty Triage',
  description: 'Training to prioritize care and maximize survival rates when multiple people are injured'
}, {
  icon: Car,
  title: 'Safe Extraction',
  description: 'Techniques to remove the injured from dangerous areas under fire, ensuring both rescuer and patient safety'
}, {
  icon: Radio,
  title: 'Emergency Communication',
  description: 'First responder communication protocols using radios and emergency networks to coordinate care'
}];
const emergencyPrograms = [{
  icon: Wind,
  title: 'CBRN Defense',
  description: 'Chemical-radiological attack survival training and protective measures for civilians in contaminated environments'
}, {
  icon: HomeIcon,
  title: 'Safe Room Protocols',
  description: 'Proper use, maintenance, and emergency protocols for home safe rooms (mamad)'
}, {
  icon: Flame,
  title: 'Evacuation Training',
  description: 'Organized procedures for home, forest fire, and flood evacuations to ensure family safety'
}, {
  icon: AlertTriangle,
  title: 'Earthquake Response',
  description: 'Drop-cover-hold techniques and post-quake evacuation procedures to minimize injuries during seismic events'
}, {
  icon: Home,
  title: 'Search & Rescue Basics',
  description: 'Fundamental techniques for locating and extracting victims from collapsed structures and building emergencies'
}, {
  icon: Siren,
  title: 'Emergency Coordination',
  description: 'Methods for coordinating emergency response with security operations during complex crisis situations'
}];
export default ProgramsPage;